import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Cog = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.3 9.6L19.4 9L20.3 7.2C20.5 6.8 20.4 6.3 20.1 6L18 3.9C17.7 3.6 17.2 3.5 16.8 3.7L15 4.6L14.4 2.7C14.3 2.3 13.9 2 13.5 2H10.5C10.1 2 9.7 2.3 9.6 2.7L8.9 4.6L7.1 3.7C6.8 3.5 6.3 3.6 6 3.9L3.9 6C3.6 6.3 3.5 6.8 3.7 7.1L4.6 8.9L2.7 9.6C2.3 9.7 2 10.1 2 10.5V13.5C2 13.9 2.3 14.3 2.7 14.4L4.6 15L3.7 16.8C3.5 17.2 3.6 17.7 3.9 18L6 20.1C6.3 20.4 6.8 20.5 7.2 20.3L9 19.4L9.6 21.3C9.7 21.7 10.1 22 10.5 22H13.5C13.9 22 14.3 21.7 14.4 21.3L15 19.4L16.8 20.3C17.2 20.5 17.6 20.4 18 20.1L20.1 18C20.4 17.7 20.5 17.2 20.3 16.8L19.4 15L21.3 14.4C21.7 14.3 22 13.9 22 13.5V10.5C22 10.1 21.7 9.7 21.3 9.6ZM12 15C10.3 15 9 13.7 9 12C9 10.3 10.3 9 12 9C13.7 9 15 10.3 15 12C15 13.7 13.7 15 12 15Z"
      fill="currentColor"
    />
  </svg>
)

export default Cog
